import axios from 'axios';
import { getApiUrl } from './helpers';

const apiClient = axios.create({
  baseURL: getApiUrl(),
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

apiClient.defaults.withXSRFToken = true;
apiClient.defaults.withCredentials = true;

export default apiClient;
